const shoes = ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47'];

export const validShoeEN = (data) => shoes.includes(data);
